import React, { FC } from 'react';

import { ICollection, IMerchant } from 'src/prize/types/shoppe';

import { HogIslandOysterCo } from './molecules/HogIslandOysterCo';

interface ICollectionsProps {
  activeCollectionId?: number;
  data: ICollection[];
  merchant: IMerchant;
}

export const Collections: FC<ICollectionsProps> = ({ activeCollectionId, data, merchant }) => {
  switch ( merchant.prizeFilePath ) {
    case 'hog_island_oyster_co':
      return <HogIslandOysterCo activeCollectionId={activeCollectionId} collections={data} />;
    default:
      return null;
  }
};
